import React, { useState } from "react";
import AppNavbar from "./Navbar";
import { Container } from "react-bootstrap";
import Footer from "./Footer";
import LoadingScreen from "../Pages/LoadingScreen";

const Layout = ({ children }) => {
  const [loading, setLoading] = useState(true);

  const handleLoadingFinish = () => {
    setLoading(false);
  };

  return (
    // Layout Component
    <div className="layout-wrapper text-white position-relative overflow-hidden">
      {/* Add Loading Screen */}
      <LoadingScreen onFinish={handleLoadingFinish} />

      {/* Background Elements */}
      <div className="animated-bg">
        <div className="grid-overlay"></div>
      </div>

      {/* <img
        src={highlightImg}
        alt="highlight"
        className="highlighted highlight-1"
      />
      <img
        src={highlightImg}
        alt="highlight"
        className="highlighted highlight-2"
      />
      <img
        src={highlightImg}
        alt="highlight"
        className="highlighted highlight-3"
      />
      <img
        src={highlightImg}
        alt="highlight"
        className="highlighted highlight-4"
      />
      <img
        src={highlightImg}
        alt="highlight"
        className="highlighted highlight-5"
      /> */}

      {/* Main Layout */}
      {!loading && (
        <div className="position-relative z-2">
          <AppNavbar />
          <Container fluid className="p-0 mt-5">
            {children}
          </Container>
          <Footer />
        </div>
      )}
    </div>
  );
};

export default Layout;
